import { placementConfigs } from './ad_ops/adPlacementMappings'

export default defineAppConfig({
  nuxtIcon: {},
  openfeature: {
    multiProvider: true,
    localProvider: false,
    queryProvider: true,
  },
  directAdsHostedConfigUrl: '',
  redesignedNtpPaths: [''],
  googleTagManagerId: '',
  urls: {
    home: '/',
    article: '/article',
    video: '/video',
  },
  outbrain: {
    installationKey: '',
  },
  adops: {
    placements: placementConfigs,
  },
  taboola: {
    publisherName: '',
  },
})
